"use client";

import React from "react";
import Image from "next/image";
import Button from "@/components/ui/Button";

const FooterCTASection: React.FC = () => {
    return (
        <section className="py-10 sm:py-15 relative overflow-hidden text-center px-4">
            <div className="flex items-center justify-center gap-4.5 mb-9.5">
                <Image src="/assets/icons/boy.svg" alt="Spot Formations Logo" width={41} height={94} />
                <h2 className="font-red-hat text-[24px] sm:text-[40px] font-light leading-8 sm:leading-13.25 text-[#1B515E]">
                    Rejoignez notre communauté de formateurs
                </h2>
                <Image src="/assets/icons/girl-with-cat.svg" alt="Spot Formations Logo" width={80} height={97} />
            </div>

            <p className="text-[14px] sm:text-[20px] leading-5 sm:leading-7.5 font-medium text-[#1D1D1D] max-w-2xl mx-auto">
                Déjà plus de [X] formateurs indépendants ont choisi Spot Formations <br className="sm:block hidden" />
                pour se libérer du marketing et se concentrer sur leur mission : transmettre.
            </p>

            <div className="flex flex-col items-center gap-5 sm:gap-9.5 mt-8 sm:mt-9.5">
                <Button variant="gradient" className="md:min-w-74">
                    Créer mon compte formateur
                </Button>
                <Button variant="outline-gradient" className="md:min-w-74">
                    En savoir plus sur les formules
                </Button>
            </div>
        </section>
    );
};

export default FooterCTASection;
